
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3544_56607)"}},[_c('rect',{attrs:{"width":"32","height":"32","rx":"6","fill":"#1BBAC8"}}),_c('path',{attrs:{"fill":"#fff","d":"M11.804 3.053H28.69V32H11.804z"}}),_c('path',{attrs:{"d":"M30.233 0H1.767C.79 0 0 .79 0 1.767v28.468C0 31.209.79 32 1.767 32h15.326V19.608h-4.17v-4.83h4.17v-3.56c0-4.134 2.524-6.385 6.212-6.385 1.767 0 3.284.132 3.727.191v4.32l-2.557.001c-2.006 0-2.394.954-2.394 2.351v3.084h4.783l-.623 4.83h-4.16V32h8.155c.973 0 1.764-.79 1.764-1.767V1.767C32 .79 31.21 0 30.233 0z","fill":"#1BBAC8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3544_56607"}},[_c('rect',{attrs:{"width":"32","height":"32","rx":"6","fill":"#fff"}})])])])
          )
        }
      }
    